module.exports = "images/apple-icon-180x180.3ed376046b529cef44aac6c5a5ed2f8f.png";